/* Prefetch a page when the visitor hovers (desktop) or touches (mobile) a link to it. */
(function () {
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  var probe = document.createElement('link');
  if (!probe.relList || !probe.relList.supports || !probe.relList.supports('prefetch')) return;

  var skip = /^\/(cart|checkout|checkouts|account|apps|admin|cdn)(\/|$)|logout|\/challenge/;
  var done = {}, count = 0, max = 15, timer = null, lastTouch = 0;

  function linkFor(target) {
    var a = target && target.closest ? target.closest('a') : null;
    if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return null;
    if (a.hasAttribute('data-no-prefetch')) return null;
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return null;
    if (a.origin !== location.origin || skip.test(a.pathname)) return null;
    if (a.pathname === location.pathname && a.search === location.search) return null;
    return a;
  }

  function prefetch(url) {
    if (done[url] || count >= max) return;
    done[url] = true;
    count++;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = url;
    document.head.appendChild(l);
  }

  var opts = { capture: true, passive: true };

  document.addEventListener('touchstart', function (e) {
    lastTouch = Date.now();
    var a = linkFor(e.target);
    if (a) prefetch(a.href.split('#')[0]);
  }, opts);

  document.addEventListener('mouseover', function (e) {
    if (Date.now() - lastTouch < 1100) return;
    var a = linkFor(e.target);
    if (!a) return;
    clearTimeout(timer);
    timer = setTimeout(function () { prefetch(a.href.split('#')[0]); }, 65);
    a.addEventListener('mouseout', function () { clearTimeout(timer); }, { passive: true, once: true });
  }, opts);
})();
